export default __webpack_public_path__ + "static/media/ShopDarkMode.262bc4a6.svg";